import { render } from "./BrowseHeader.vue?vue&type=template&id=4721d8f4&scoped=true"
import script from "./BrowseHeader.vue?vue&type=script&lang=js"
export * from "./BrowseHeader.vue?vue&type=script&lang=js"

import "./BrowseHeader.vue?vue&type=style&index=0&id=4721d8f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4721d8f4"]])

export default __exports__